module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/about.svg?d364d81ab04063011d946542d32fe27a";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/about.svg
// module id = 11
// module chunks = 0